














































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import CommunicationWidgetDto from "@/services/CommunicationWidgetDto";
import { saveAs } from 'file-saver';
import ReadingCommunicationWidget from '@/services/ReadingCommunicationWidget';
import { ClaimEnum } from '@/services/ClaimEnum';  
import { ReadingCountryDto } from '@/interfaces/readingCommunicationDto';

export class Widget {
  constructor(nameCategory?: string, idCategory?: string,widgetContent?: Array<WidgetContent>) {
    this.nameCategory = nameCategory;
    this.idCategory = idCategory;
    widgetContent
      ? (this.widgetContent = widgetContent)
      : (this.widgetContent = new Array<WidgetContent>());
  }
  nameCategory: string;
  widgetContent: Array<WidgetContent> =
    new Array<WidgetContent>();
  idCategory : string;
}

export class WidgetContent {
  constructor(nameSubCategory?: string,communicationWidget?: Array<ReadingCommunicationWidget>,viewSubCategory?:boolean) {
    this.nameSubCategory = nameSubCategory;
    communicationWidget
      ? (this.communicationWidget = communicationWidget)
      : (this.communicationWidget = new Array<ReadingCommunicationWidget>());
    (viewSubCategory) ? this.viewSubCategory = viewSubCategory : this.viewSubCategory = false;
  }
  nameSubCategory:string;
  communicationWidget: Array<ReadingCommunicationWidget> = new Array<ReadingCommunicationWidget>();
  viewSubCategory:boolean;
}

interface OptionShowed{
        value: string,
        text: string
        
    }

@Component
export default class CommunicationsPortalWidget extends Vue {
  isAuthorized: boolean = false;
  loading: boolean = false;
  communicationWidget = new Array<Widget>();
  communicationSelected = new CommunicationWidgetDto();
  idCategorySelected : string = null;
  COMM_MODAL_ID = "communication-detail-modal";
  COMM_MODAL_CHANGE_COUNTRY = "commmunication-change-country";
  optionsCountries:OptionShowed[]=null;
  optionsContracts:OptionShowed[]=null;
  countryIsoSelected: string = null;
  contractSelected: string = null;
  isSaveClicked: boolean = false;
  countryIsoForced: string = null;
  contractForced: string = null;
  loadingModalCountryChange: boolean = false;
  general: any = {};


  trucateString(string: string, index: number) {
    return General.truncate(string, index, "...");
  }

   getSubCategoryName(subCategory:WidgetContent):string{
    return (subCategory.nameSubCategory) ?  subCategory.nameSubCategory :  "Generic";
  }

  redirectCommSearchPage(widgetContent:CommunicationWidgetDto){    
    General.goToPage("/communications/category=" + widgetContent.idCategory,this.$router);    
  }

  closeModal(){

    this.$bvModal.hide(this.COMM_MODAL_ID);
  }

  async showCommunicationDo(idCommunication: string, isPublicId : boolean = false) : Promise<void> {
    await this.getCommunicationWidget(idCommunication, isPublicId);
    this.$bvModal.show(this.COMM_MODAL_ID);
  }


  triggerIsNewValue(communication : ReadingCommunicationWidget){
    let comm = this.communicationWidget.find(x => x.widgetContent.find(y => y.communicationWidget.find(c => c.idCommunication == communication.idCommunication))).widgetContent[0].communicationWidget[0];
    if(comm && comm.isNew)
      comm.isNew = false;
      console.log(communication);
  }

  containsAnySubCategory(widget: Widget) : boolean{
    return widget.widgetContent.find(x => x.nameSubCategory) != null;
  }


  async downloadAttachmentById(attachment){
             try {
                let response = await axios({
                    method: 'get',
                    url: General.GetApiUrl("/api/communication/DownloadAttachment?id="+attachment.id),
                    withCredentials: true,
                    responseType: 'blob'
                });
                saveAs(new Blob([response.data]), attachment.name);
            } catch (error) {
                General.showAlertDanger("Download error, please retry. If the problem stll present contact your IT", this);                               
            }
  }


  async getCommunicationWidget(idCommunciation: string, isPublicId : boolean = false) {
    General.mainLoading(true);
    let response;
    this.communicationSelected = null;
    try {
      if(!isPublicId) {
          response = await axios.get<CommunicationWidgetDto>(
          General.GetApiUrl(
            "/api/communication/GetCommunicationWidgetById?idCommunication=" +
              idCommunciation
          ),
          { withCredentials: true }
        );
      } else {
        response = await axios.get<CommunicationWidgetDto>(
          General.GetApiUrl(
            "/api/communication/GetCommunicationWidgetByPublicId?idCommunicationPublic=" +
              idCommunciation
          ),
          { withCredentials: true }
        );
      }

      if (response.data) 
        this.communicationSelected = response.data;
    } catch (error) {
      General.HandleError(error,this);
    }finally{
      General.mainLoading(false);
    }
  }
  communicationsFilter(communicationList: Array<any>) {
    let app = this;
    communicationList.forEach(function(communicationWidgetDto:ReadingCommunicationWidget){
      // if(!communicationWidgetDto.nameSubCategory)
      // communicationWidgetDto.nameSubCategory = "undefined";
      if(!app.communicationWidget.find(x => x.nameCategory == communicationWidgetDto.nameCategory)){
        app.communicationWidget.push(new Widget(communicationWidgetDto.nameCategory,communicationWidgetDto.idCategory,new Array<WidgetContent>())); 
      }
        let comm = app.communicationWidget.find(x => x.nameCategory == communicationWidgetDto.nameCategory);
        if(comm){
          if(!communicationWidgetDto.nameSubCategory){
        let commNullSubCategory = comm.widgetContent.find(x => x.nameSubCategory == null);
          if(!commNullSubCategory)
             comm.widgetContent.push(new WidgetContent(communicationWidgetDto.nameSubCategory,new Array<ReadingCommunicationWidget>()))
          
          else commNullSubCategory.communicationWidget.push(communicationWidgetDto);
          }
        else
        if(!comm.widgetContent.find(x => x.nameSubCategory == communicationWidgetDto.nameSubCategory)){
            comm.widgetContent.push(new WidgetContent(communicationWidgetDto.nameSubCategory,new Array<ReadingCommunicationWidget>()))
        }
             let commWidget = comm.widgetContent.find(x => x.nameSubCategory == communicationWidgetDto.nameSubCategory);
             if(!commWidget.communicationWidget.find(x => x.idCommunication == communicationWidgetDto.idCommunication)){
              commWidget.communicationWidget.push(communicationWidgetDto)
             }
        }
    });
}
  async getCommunicationWidgets(){
    this.countryIsoForced = this.$route.query.countryCodeIso as string;
    this.contractForced = this.$route.query.contractType as string;

        
    let communicationWidget = await this.getWidgets()    
    if(communicationWidget.length > 0)
    this.communicationsFilter(communicationWidget);
  }

  async mounted() {
    await this.getCommunicationWidgets();  
    this.general = General;
    this.isAuthorized = General.CheckAuthorization(ClaimEnum.CanShowCommunications);
    this.contractSelected = "1";

    if(this.$route.path.search("/communications-view/") > -1) {
      let commPublicId = this.$route.params.id.replace('/communications-view/','');  
      this.showCommunicationDo(commPublicId, true);
    }
  }

  async getWidgets() : Promise<[ReadingCommunicationWidget]>{
    this.loading = true;
    
    var widgetsUrl = "/api/communication/GetWidgets";
    
    if (this.countryIsoForced!=undefined)  widgetsUrl += "?countryCodeIso="+this.countryIsoForced+"&contractType="+this.contractForced;
    
    try {
      let response = await axios.get<any>(
        General.GetApiUrl(widgetsUrl),
        {
          withCredentials: true,
        }
      );
      if (response.data) return response.data;
    } catch (error) {
      General.HandleError(error, this);
    }
    finally{
      this.loading = false;
    }
  }

  async addUserReadingCommunication(idCommunication: string,actionConfirmation:string) {
    General.confirm(
      "Do you want confirm this communication like:" + actionConfirmation + "?",
      this,
      async () => {       
      try {
        this.loading = true;
        await axios.get(
          General.GetApiUrl("/api/Communication/AddUserReadingConfirmation?id=" + idCommunication + "&actionConfirmation=" + actionConfirmation),
          { withCredentials: true }
        );
        this.loading = false;
        this.$bvModal.hide(this.COMM_MODAL_ID);
      } catch (error) {
        General.HandleError(this, error);
      }
    })
  }

  containNewElement(widgetContent : WidgetContent): boolean{
    return widgetContent.communicationWidget.find(y => y.isNew) != null;
  }

  setViewSubCategory(subCategory:WidgetContent){
    subCategory.viewSubCategory = !subCategory.viewSubCategory;
  }

  get userCanManageCommunications() {            
    return General.CheckAuthorization(ClaimEnum.CanManageCommunications);
  }
  async openModalChangeCountry(){
    this.isSaveClicked = false;
    this.countryIsoSelected = null;
    this.$bvModal.show(this.COMM_MODAL_CHANGE_COUNTRY);
    if (this.optionsCountries==null) this.optionsCountries = await this.getCountries();
    this.optionsContracts = new Array();
    this.optionsContracts.push({
        value: "1",
        text: "INTERNAL"
    });
    this.optionsContracts.push({
        value: "2",
        text: "EXTERNAL"
    });
  }

  async getCountries(): Promise<Array<OptionShowed>> {
      try {
        this.loadingModalCountryChange = true;
        let countries: Array<ReadingCountryDto> = (await axios.get<Array<ReadingCountryDto>>(
            General.GetApiUrl('/api/Communication/GetCountriesForUser')                   
            ,{                        
                withCredentials: true,
                responseType: 'json'
            }
        )).data

        let countriesShowed: Array<OptionShowed> = new Array();
          
        countries.forEach(country => {
          if(this.countryIsoForced!=country.code){
            countriesShowed.push({
                value: country.code,
                text: country.name
            })
          }
        });
        this.loadingModalCountryChange = false;
        return countriesShowed;
      } catch (e) {
          console.log(e)
          General.showAlertDanger("Cannot retrieve the list of countries!", this)
      }
  }
  changeCountry(){
    this.isSaveClicked = true;
    if (this.countryIsoSelected!=null){
      window.location.href="/?countryCodeIso="+this.countryIsoSelected+"&contractType="+this.contractSelected;;
    }


  }
  resetCountry(){
    window.location.href="/";

  }
  returnState(condition: boolean, clickButton: boolean): boolean {
      if (clickButton) 
        return condition;
      else 
        return null;
    }
  
  
}

